import { createBrowserRouter } from 'react-router-dom';
import projectRoutes from './projects';
import PageHome from '@pages/home';
import HomeLayout from '@components/Layouts/HomeLayout';
import StandarLayout from '@components/Layouts/StandarLayout';
import WhatIDoPage from '@pages/what-i-do';
import CognitiveFormPage from '@pages/cognitive-form';
import SessionCollectorPage from '@pages/session-collector';
import SessionDataPage from '@pages/session-data';
import MyCardPage from '@pages/my-card';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <HomeLayout>
        <PageHome />
      </HomeLayout>
    )
  },
  {
    path: '/what-i-do',
    element: (
      <StandarLayout>
        <WhatIDoPage />
      </StandarLayout>
    )
  },
  {
    path: '/cognitive-form',
    element: (
      <StandarLayout>
        <CognitiveFormPage />
      </StandarLayout>
    )
  },
  {
    path: '/session-collector',
    element: (
      <StandarLayout>
        <SessionCollectorPage />
      </StandarLayout>
    )
  },
  {
    path: '/session-data',
    element: (
      <StandarLayout>
        <SessionDataPage />
      </StandarLayout>
    )
  },
  {
    path: '/my-card',
    element: (
      <StandarLayout>
        <MyCardPage />
      </StandarLayout>
    )
  },
  ...projectRoutes
]);

export default router;
